var map = {
	"./Merajul_CV.pdf": 52,
	"./Merajul_Resume.pdf": 972,
	"./education.svg": 428,
	"./interests.svg": 372,
	"./programming-skills.svg": 821,
	"./projects.svg": 51,
	"./work-history.svg": 101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;